<template>
    <div class="container" style="background-color:#fff;border-right:1px solid #ddd;border-left:1px solid #ddd;margin-top:0px;">

      <div
        style="
          
          padding: 60px 0px;;
          text-align: center;
          
          
        "
      >
        <span style="color: #666; font-size: 18px"
          ><i class="bi bi-gear"></i><br />Loading maps and data...</span
        >
      </div>
    </div>

</template>

<script>
export default {
    name: 'Loading',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    created() {
    },
    computed: {
    },
    mounted() {
    }
}
</script>

<style scoped>

</style>